// extracted by mini-css-extract-plugin
export default {"swatch":"DesignSection_swatch__j+Pmx"};